import { TwoFactorChallengeType } from '@afterpaytouch/portal-api/consumer/auth/types'

interface CountryAgeRestriction {
  DEFAULT: number
  [key: string]: number
}

export const getFormFields = (mandatoryFields: TwoFactorChallengeType[]): ChallengesForm => {
  const initialValue = {}
  return mandatoryFields.reduce((object, challengeType) => {
    object[challengeType] = ''
    return object
  }, initialValue)
}

export interface ChallengesForm {
  PHONE_NUMBER?: string
  DATE_OF_BIRTH?: string
  CREDIT_CARD?: string
  LAST_NAME?: string
}

export const MINIMUM_AGE_RESTRICTION: {
  [key: string]: CountryAgeRestriction
} = {
  US: {
    DEFAULT: 18,
  },
  CA: {
    AB: 18,
    MB: 18,
    ON: 18,
    PE: 18,
    QC: 18,
    SK: 18,
    DEFAULT: 19,
  },
  DEFAULT_COUNTRY: {
    DEFAULT: 18,
  },
} as const

export const MAX_AGE_RESTRICTION = 105
